import theme from "./BaseTheme";

export default theme;
